module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.jakesdivinity.org",
    "title": "Jakes Divinity School",
    "tfn": "",
    "url": "https://info.jakesdivinity.org",
    "gtm_code": "GTM-WH9WX3T",
}